module.exports = __webpack_public_path__ + "static/media/alexis_mac_allister.69cee6ad.jpg";